import React from "react";
import { Link, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CopyToClipboard from "react-copy-to-clipboard";
import { useActions } from "../../../actions";
import * as AccountActions from "../../../actions/account";
import * as AgentLinksActions from "../../../actions/agentLinks";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import TableWrap from "../../../components/TableWrap/TableWrap";
import {
    LOGO_BASE_URL,
    MARKETING_SITE_KAIZEN_ALZURL,
    MARKETING_SITE_KAIZEN_NLGURL,
    MARKETING_SITE_URL,
    MARKETING_SITE_URL_GEN1_ALZ,
    MARKETING_SITE_URL_GEN1_NL,
    NY_AGENT,
} from "../../../constants";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& > *": {
				margin: theme.spacing(1),
			},
		},
		input: {
			display: "none",
		},
		margin: {
			margin: theme.spacing(1),
		},
		table: {
			minWidth: 767,
		},
		tableHead: {
			backgroundColor: "#F4F6F8",
		},
		f18: {
			fontSize: 18,
		},
		width150: {
			width: 150,
		},
		container: {
			maxHeight: 600,
		},
	})
);

const APP_URL: string = window.location.origin;

const LinksTable = (props: any) => {
	const { userId } = props;
	const [inviteTokenId, setInviteTokenId] = React.useState<number>(0);
	const accountActions = useActions(AccountActions);
	const classes = useStyles();
	const agentLinksActions = useActions(AgentLinksActions);
	const [linksTable, setLinksTable] = React.useState([]);
	React.useEffect(() => {
		getList(userId || "").then(() => {});
	}, []);

	const getList = async (userId: string) => {
		let listData = await agentLinksActions.getAgentLinks(userId);
		setLinksTable(listData);
	};

	function valHandler(linkId: number) {
		setInviteTokenId(linkId);
		accountActions.copyInvitationLink(
			"Link URL Has Been Copied to Your Clipboard"
		);
	}


	return (
		<TableWrap>
			<TableHead className={classes.tableHead}>
				<TableRow>
					<TableCell className={classes.f18} padding={"default"}>
						Ilia Product Type
					</TableCell>
					<TableCell className={classes.f18} padding={"default"}>
						Link URL
					</TableCell>
					<TableCell
						className={classes.f18 + " " + classes.width150}
						padding="default"
						align="center"
					>
                        Qualifications
					</TableCell>
                    <TableCell
						className={classes.f18 + " " + classes.width150}
						padding="default"
						align="left"
					>
						Actions
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{linksTable.length > 0 ? (
					linksTable.map((link: any, index: number) => {
						let productType = link.strategy.displayName + " (" +  link.carrier.carrierName +  ")";
						let agentLink =
							NY_AGENT === link.guid
								? MARKETING_SITE_URL + link.guid
								: APP_URL + "/agent-link/" + link.guid;
						if ([1, 4, 5, 6].includes(link.strategy.id)) {
							agentLink = MARKETING_SITE_KAIZEN_NLGURL + link.guid;
							if (link.carrier.id == 3) {
								agentLink = MARKETING_SITE_KAIZEN_ALZURL + link.guid;
							}
						} else if (link.strategy.id == 8) {
							agentLink = MARKETING_SITE_URL_GEN1_NL + link.guid;
							if (link.carrier.id == 3) {
								agentLink = MARKETING_SITE_URL_GEN1_ALZ + link.guid;
							}
							productType = link.strategy.displayName.replace("2", "1")  + " (" +  link.carrier.carrierName +  ")"
						}
						return (
							<TableRow hover key={index}>
								<TableCell padding={"default"}>
									{productType}
								</TableCell>
								<TableCell padding={"default"}>
									{/*<Link onClick={() => window.open(APP_URL + "/agent-link/" + link.guid)}>*/}
									{/*    {APP_URL + "/agent-link/" + link.guid}*/}
									{/*</Link>*/}
									<Link onClick={() => window.open(agentLink)}>
										{agentLink}
									</Link>
								</TableCell>

                                <TableCell padding="default" align="center">
                                    { link.strategy.id == 8 &&
                                    <Link
                                            href={`${LOGO_BASE_URL}docs/Kai-Zen+Process+and+Qualification+for+GWT.pdf`}
                                            target="_blank">
                                        <PictureAsPdfIcon/>
                                    </Link>}
								</TableCell>

								<TableCell padding={"default"}>
									<Tooltip
										placement="left-start"
										title={
											link.id === inviteTokenId ? (
												<React.Fragment>
													Link URL Has Been <br />
													Copied to Your Clipboard
												</React.Fragment>
											) : (
												"Copy Link URL"
											)
										}
									>
										<CopyToClipboard
											text={agentLink}
											onCopy={() => valHandler(link.id)}
										>
											<Link>
												{" "}
												<FileCopyOutlinedIcon className="mr10" />
												<span>Copy Link</span>
											</Link>
										</CopyToClipboard>
									</Tooltip>
								</TableCell>
							</TableRow>
						);
					})
				) : (
					<TableRow hover>
						<TableCell padding={"default"} colSpan={6}>
							<Typography variant="caption" className="floatLeft">
								There are no URL links available!
							</Typography>
						</TableCell>
					</TableRow>
				)}
			</TableBody>
		</TableWrap>
	);
};

export default LinksTable;
